import { render, staticRenderFns } from "./CopyAndResizeTemplateModal.vue?vue&type=template&id=74c41a52"
import script from "./CopyAndResizeTemplateModal.vue?vue&type=script&lang=js"
export * from "./CopyAndResizeTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./CopyAndResizeTemplateModal.vue?vue&type=style&index=0&id=74c41a52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports